import {useEffect, useState} from 'react';

const RealTimeDisplay = ({ updateInterval, children }) => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTime(new Date());
        }, updateInterval);

        return () => clearInterval(intervalId);
    }, [updateInterval]);

    return children(time); // Pass the updated time to children as a function argument
};

export default RealTimeDisplay;